export default {
      id: "vague_connecte-usage",
      viewBox: "0 0 500 180",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#vague_connecte-usage",
      toString: function () {
        return this.url;
      }
    }